import React, { useEffect, useState } from 'react'
import { AppBar, Box, Button, IconButton, Menu, MenuItem, Stack, TextField, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'
import { Link, useNavigate } from 'react-router-dom';
import mobile from '../lib/mobile';
import { Search } from '@mui/icons-material';
import BuscarEmpresas from '../componentes/BuscarEmpresas';
import SelectEstado from '../componentes/SelectEstado';
import SelectActividad from '../componentes/SelectActividad';
import NavBtn from '../componentes/NavBtn';
export default function NavBar({ handleSearch, handleActividad, handleFilterEstado }) {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    const [mostrarBuscar, setMostrarBuscar] = useState(false);
    useEffect(() => {
        setIsMobile(mobile());
    }, [])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleBuscar = (val) => {
        handleSearch(val);
    }

    if (['/', '/index', '/empresas', '/organismos', '/agregar', '/agregar_organismo', '/empresas_no_publicadas', '/organismos_no_publicados'].includes(window.location.pathname) || isMobile) {
        return (
            <AppBar position="static" sx={{ p: 0, m: 0, flexGrow: 1, backgroundColor: '#fff', boxShadow: 0, color: 'black' }} enableColorOnDark >
                <Toolbar>
                    {/* Menu PC */}
                    {!isMobile &&
                        <React.Fragment>
                            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'start' }}>

                                {['/empresas', '/agregar', '/'].includes(window.location.pathname) &&
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <NavBtn
                                            color="inherit"
                                            onMouseDown={(e) => {
                                                if (e.button === 1) {
                                                    window.open('https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/', '_blank');
                                                }
                                            }}
                                            onClick={() => {
                                                if (window.location.pathname == '/empresas') {
                                                    window.location.reload();
                                                } else {
                                                    navigate('/empresas');
                                                }
                                            }}
                                        >
                                            Listado Empresas
                                        </NavBtn>
                                        <NavBtn color="inherit">
                                            <Link to="/agregar">
                                                Nueva Empresa Social
                                            </Link>
                                        </NavBtn>
                                    </Box>
                                }

                                {/* //! CAMBIAR POR NUEVA URL */}
                                {['/organismos', '/agregar_organismo', '/index'].includes(window.location.pathname) &&
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        <NavBtn color="inherit"
                                            onMouseDown={(e) => {
                                                if (e.button === 1) {

                                                    window.open('https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/', '_blank');
                                                }
                                            }}
                                            onClick={() => {
                                                if (window.location.pathname == '/organismos') {
                                                    window.location.reload();
                                                } else {
                                                    navigate('/organismos');
                                                }
                                            }}>
                                            Listado Organismos
                                        </NavBtn>
                                        <NavBtn color="inherit">
                                            <Link to="/agregar_organismo">
                                                Nuevo Organismo Cooperativo
                                            </Link>
                                        </NavBtn>
                                    </Box>
                                }
                                {['/empresas_no_publicadas', '/organismos_no_publicados'].includes(window.location.pathname) &&
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <NavBtn color="inherit"
                                            onClick={() => {
                                                navigate('/empresas_no_publicadas');
                                            }}>
                                            Administración de perfiles
                                        </NavBtn>
                                        <NavBtn color="inherit"
                                            onClick={() => {
                                                navigate('/organismos_no_publicados');
                                            }}>
                                            Administración de organismos
                                        </NavBtn>
                                        <NavBtn color="inherit"
                                            onClick={() => {
                                                window.open('https://empresas-economiasocialysolidaria.com.mx/publicar-blogs/', '_blank')
                                            }}>
                                            Publicar Estudios
                                        </NavBtn>
                                    </Box>
                                }
                            </Box>
                            {/* filtros */}
                            {
                                ["/organismos", "/empresas"].includes(window.location.pathname) &&
                                <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 2 }}>
                                    <SelectEstado onSelect={handleFilterEstado} />
                                    <SelectActividad onSelect={handleActividad} />
                                    <BuscarEmpresas buscar={handleBuscar} />
                                </Box>
                            }

                        </React.Fragment>
                    }
                    {/* Menu celular */}
                    {isMobile &&

                        <Stack
                            sx={{
                                width: '100%',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                borderRadius: 1,
                                p: 1.5
                            }}
                            direction="column"
                            justifyContent="space-between"
                            alignItems="center"
                            spacing={2}
                        >
                            {window.location.pathname == '/empresas' &&
                                <>

                                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <BuscarEmpresas cerrar={() => setMostrarBuscar(false)} buscar={handleBuscar} /> :
                                    </Box>
                                    <Box sx={{
                                        width: '100%',
                                        py: 1.5,
                                        px: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                        borderRadius: 1
                                    }}>
                                        <SelectEstado onSelect={handleFilterEstado} fullWidth />
                                        <SelectActividad onSelect={handleActividad} fullWidth />
                                    </Box>


                                    <Stack direction="row" sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 2 }}>
                                        <NavBtn
                                            color="inherit"
                                            onMouseDown={(e) => {
                                                if (e.button === 1) {
                                                    window.open('https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/', '_blank');
                                                }
                                            }}
                                            onClick={() => {
                                                if (window.location.pathname == '/empresas') {
                                                    window.location.reload();
                                                } else {
                                                    navigate('/empresas');
                                                }
                                            }}
                                        >
                                            Listado Empresas
                                        </NavBtn>
                                        <NavBtn color="inherit">
                                            <Link to="/agregar">
                                                Nueva Empresa Social
                                            </Link>
                                        </NavBtn>
                                    </Stack>
                                </>
                            }
                        </Stack>
                        // <React.Fragment>
                        //     <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center' }}>
                        //         <Button onClick={handleClick} variant="outlined" sx={{ borderColor: '#fff', '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255, 255, 255, 0.1)' } }}>
                        //             <MenuIcon sx={{ color: '#fff' }} />
                        //         </Button>
                        //     </Box>
                        //     {/* Buscador movil */}
                        //     {window.location.pathname == '/empresas' &&
                        //         <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                        //             {mostrarBuscar ? <BuscarEmpresas cerrar={() => setMostrarBuscar(false)} buscar={handleBuscar} /> :
                        //                 <Button onClick={() => { setMostrarBuscar(true) }} variant="outlined" sx={{ borderColor: '#fff', '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255, 255, 255, 0.1)' } }}>
                        //                     <Search sx={{ color: '#fff' }} />
                        //                 </Button>
                        //             }
                        //         </Box>
                        //     }
                        //     <Menu
                        //         id="basic-menu"
                        //         anchorEl={anchorEl}
                        //         open={open}
                        //         onClose={handleClose}
                        //         MenuListProps={{
                        //             'aria-labelledby': 'basic-button',
                        //         }}
                        //     >
                        //         <MenuItem onClick={() => {
                        //             handleClose();
                        //             navigate('/empresas')
                        //         }}>Listado</MenuItem>
                        //         <MenuItem onClick={() => {
                        //             handleClose();
                        //             navigate('/agregar')
                        //         }}>Agregar Empresa</MenuItem>
                        //     </Menu>
                        // </React.Fragment>
                    }
                </Toolbar>
            </AppBar >

        )
    }
}